/**
 * PushController — /api/v1/push
 * Mirrors: src/Aidepo.Api/Controllers/PushController.cs
 *
 * Phase 4.6 — Web Push. GET vapid отдаёт публичный ключ для
 * PushManager.subscribe(); POST subscribe сохраняет полученную подписку.
 */
import { apiGet, apiPost } from '../client.js';

export interface VapidResponse {
  /** false — push на сервере не настроен (нет VAPID-ключей). */
  readonly enabled: boolean;
  readonly publicKey: string | null;
}

/** Форма PushSubscription.toJSON() — то, что отдаёт браузер. */
export interface PushSubscribePayload {
  readonly endpoint: string;
  readonly keys: {
    readonly p256dh: string;
    readonly auth: string;
  };
}

/** GET /api/v1/push/vapid — публичный VAPID-ключ. */
export function getVapidKey(): Promise<VapidResponse> {
  return apiGet<VapidResponse>('/api/v1/push/vapid');
}

/** POST /api/v1/push/subscribe — сохранить подписку браузера. */
export function subscribePush(payload: PushSubscribePayload): Promise<{ status: string }> {
  return apiPost<{ status: string }, PushSubscribePayload>('/api/v1/push/subscribe', payload);
}
